module.exports = __webpack_public_path__ + "assets/img/index-partner26.131045bc.jpg";